import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Jumbotron } from 'reactstrap';

import { ROOT_REGION_ID, ROOT_REGION_TITLE } from 'upstream-shared/constants';

// import { useAppSelector } from '../../hooks';
// import { UpstreamToken } from 'upstream-shared/models';
import { paths } from '../../paths';
import LocalOperatorsList from '../Operator/components/LocalOperatorList';
import LocalWellList from '../Well/components/LocalWellList';
import TopLevelRegion from '../Region/components/TopLevelRegion';
import LocalRegionList from '../Region/components/LocalRegionList';
import RecentSourceList from '../Source/components/RecentSourceList';
import RecentTransferList from '../Transfer/components/RecentTransferList';
import LazyMotionProvider from '../../components/LazyMotionProvider/LazyMotionProvider';
import { ModalTrigger } from '../../components/Modal/Modal';
import './home.css';
import { upstreamApi } from '../../upstreamApi';
import HomePageModalContent from '../../components/HomePageModalContent/HomePageModalContent';

const OPERATORS_STORE = 'homeOperatorsStore';
const OPERATORS_QUERYSTRING = JSON.stringify({
  skip: 0,
  limit: 10,
  sort: [{ regionSummary: { field: 'boeTotal', regionId: ROOT_REGION_ID, order: 'desc' } }],
  filters: { isProducing: true, parentId: null },
});
const OPERATORS_HIDE_FIELDS: string[] = ['city', 'wellCount', 'wellStates'];

const WELLS_STORE = 'homeWellsStore';
const WELLS_QUERYSTRING = JSON.stringify({
  skip: 0,
  limit: 10,
  sort: [{ 'prodSummary.boeTotal': 'desc' }],
  filters: { status: 'ACTV' },
});
const WELLS_HIDE_FIELDS: string[] = ['api', 'stateAbbrev', 'type', 'config', 'status', 'spud'];

const STATES_STORE = 'homeStatesStore';
const STATES_QUERYSTRING = JSON.stringify({
  skip: 0,
  limit: 10,
  sort: [{ boeTotal: 'desc' }],
  filters: { level: 2 },
});
const STATES_HIDE_FIELDS: string[] = ['stateAbbrev', 'dataFrom', 'dataTo', 'producingOperatorCount', 'wellCount'];

const COUNTIES_STORE = 'homeCountiesStore';
const COUNTIES_QUERYSTRING = JSON.stringify({
  skip: 0,
  limit: 10,
  sort: [{ boeTotal: 'desc' }],
  filters: { level: 3 },
});
const COUNTIES_HIDE_FIELDS: string[] = ['dataFrom', 'dataTo', 'producingOperatorCount', 'wellCount', 'stateAbbrev'];

const SOURCES_STORE = 'homeSourcesStore';
const SOURCES_QUERYSTRING = JSON.stringify({
  skip: 0,
  limit: 10,
  sort: [{ processedOn: 'desc' }, { stateAbbrev: 'asc' }, { dataType: 'asc' }],
});

const TRANSFERS_STORE = 'homeTransfersStore';
const TRANSFERS_QUERYSTRING = JSON.stringify({
  skip: 0,
  limit: 10,
  sort: [{ transferDate: 'desc' }],
});

const IMAGES_BASE_URL = `${process.env.PUBLIC_URL}/`;
const styles = {
  jumbo: {
    backgroundImage: `url(${IMAGES_BASE_URL}overview.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundBlendMode: 'lighten',
  },
};

const Home = () => {
  // const authUser: UpstreamToken | undefined = useAppSelector((state) => state.auth.authUser);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const data = await upstreamApi.auth.getTerms();
        if (!data.termsAccepted) setOpen(true);
      } catch {
        // tslint:disable: no-console
        console.log('Error checking terms acceptance');
      }
    })();
  }, []);

  const handleAccept = async () => {
    await upstreamApi.auth.acceptTerms();
    setOpen(false);
  };

  return (
    <LazyMotionProvider>
      <main className={'mainContent'}>
        <Jumbotron style={styles.jumbo}>
          <h2>Welcome to CARA’s Upstream energy platform...</h2>
          <p>
            with access to oil and gas well, transfer, production, and ownership information from {ROOT_REGION_TITLE} in the
            regions we cover.
          </p>
          <hr className="my-2" />
          <p className="lead">
            <a title={'Visit The CARA.org'} className={'btn btn-secondary'} href={paths.CARA}>
              Learn more
            </a>
            {/* {!authUser && (
            <Link title={'Go to page to request a login email'} className={'btn btn-primary ml-4'} to={paths.LOGIN}>
              Login
            </Link>
          )} */}
          </p>
        </Jumbotron>
        <div className={'mt-4'}>
          <Row>
            <Col lg={6} xl={4} className={'mb-4'}>
              <RecentSourceList
                storeIdentifier={SOURCES_STORE}
                queryString={SOURCES_QUERYSTRING}
                label={'Recent Data Source Updates'}
              >
                <Link to={paths.LIST_SOURCES}>
                  <Button>View All</Button>
                </Link>
              </RecentSourceList>
            </Col>
            <Col lg={6} xl={4} className={'mb-4'}>
              <TopLevelRegion />
            </Col>
            <Col lg={6} xl={4} className={'mb-4'}>
              <LocalOperatorsList
                storeIdentifier={OPERATORS_STORE}
                queryString={OPERATORS_QUERYSTRING}
                hideFields={OPERATORS_HIDE_FIELDS}
                label={'Top Operators'}
                hideCount
              >
                <Link to={paths.LIST_OPERATORS}>
                  <Button>View All</Button>
                </Link>
              </LocalOperatorsList>
            </Col>
            <Col lg={6} xl={4} className={'mb-4'}>
              <LocalWellList
                storeIdentifier={WELLS_STORE}
                queryString={WELLS_QUERYSTRING}
                hideFields={WELLS_HIDE_FIELDS}
                label={'Top Active Wells'}
                hideCount
              >
                <Link to={paths.LIST_WELLS}>
                  <Button>View All</Button>
                </Link>
              </LocalWellList>
            </Col>
            <Col lg={6} xl={4} className={'mb-4'}>
              <LocalRegionList
                storeIdentifier={STATES_STORE}
                queryString={STATES_QUERYSTRING}
                hideFields={STATES_HIDE_FIELDS}
                label={'Top States'}
                hideCount
              >
                <Link to={paths.LIST_REGIONS}>
                  <Button>View All</Button>
                </Link>
              </LocalRegionList>
            </Col>
            <Col lg={6} xl={4} className={'mb-4'}>
              <LocalRegionList
                storeIdentifier={COUNTIES_STORE}
                queryString={COUNTIES_QUERYSTRING}
                hideFields={COUNTIES_HIDE_FIELDS}
                label={'Top Counties'}
                hideCount
              >
                <Link to={paths.LIST_REGIONS}>
                  <Button>View All</Button>
                </Link>
              </LocalRegionList>
            </Col>
            <Col lg={6} xl={4} className={'mb-4'}>
              <RecentTransferList
                storeIdentifier={TRANSFERS_STORE}
                queryString={TRANSFERS_QUERYSTRING}
                label={'Recent Well Transfers'}
              >
                <Link to={paths.LIST_TRANSFERS}>
                  <Button>View All</Button>
                </Link>
              </RecentTransferList>
            </Col>
          </Row>
        </div>

        <ModalTrigger
          isOpen={open}
          modalStyle="homeModal"
          dialogOptions={{ isDismissable: false, isKeyboardDismissDisabled: true }}
          dismissButtonStyle="homeDismissButton"
          content={<HomePageModalContent onAccepted={handleAccept} privacyPolicyHref="https://www.thecara.org/privacy" />}
          hideDismissButton
        >
          {() => null}
        </ModalTrigger>
      </main>
    </LazyMotionProvider>
  );
};

export default Home;
